import React, { Children, useRef, useEffect, useState } from "react";
import classNames from "classnames";

import { actions } from "reducers/drawer";

import Button from "pages/_components/Button";
// import Button from "pages/_components/Button";

const Options = (props) => {
    const { children, options, handleClose, dispatch } = props;
    const optionsRef = useRef(null);

    const handleClickOutside = (event) => {
        if (optionsRef.current && !optionsRef.current.contains(event.target)) {
            handleClose();
        }
    };
    useEffect(() => {
        document.addEventListener("click", handleClickOutside, true);
        return () => {
            document.removeEventListener("click", handleClickOutside, true);
        };
    }, [handleClickOutside]);

    return (
        <div className={classNames("slider", "slideFromBottom", { "is-shown": !!options?.length })}>
            <div ref={optionsRef} className="slideFromBottom-wrapper">
                <Button block className="btn btn-link drawer-close" onClick={handleClose} image="drawer-close.svg" />
                <ul className="navigational-list">
                    {Children.map(
                        children,
                        (child, index) =>
                            child &&
                            React.cloneElement(
                                child.key !== "account.transfers" ? (
                                    <li className="navigational-list-item" key={index}>
                                        {child}
                                    </li>
                                ) : (
                                    <ul className="navigational-list">{child}</ul>
                                ),
                            ),
                    )}
                </ul>
                {/* <Button
                            block
                            className="btn btn-outline"
                            label="global.cancel"
                            onClick={handleClose}
                        /> */}
            </div>
        </div>
    );
};

export default Options;
